import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/DodecahedronGeometry'

export default meshComponent('Dodecahedron', props, createGeometry)
